import { useContext } from 'react';
import { AllFeatureGroupsContext } from './IndexPage';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RolloutFeatureGroups({
  featureGroups
}) {
  const {
    allFeatureGroups,
    isLoadingFeatureGroups
  } = useContext(AllFeatureGroupsContext);
  if (!allFeatureGroups || allFeatureGroups.size === 0 || isLoadingFeatureGroups) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: featureGroups.map((featureGroup, index) => {
      var _allFeatureGroups$get;
      return allFeatureGroups.get(featureGroup) && /*#__PURE__*/_jsxs("span", {
        children: [(_allFeatureGroups$get = allFeatureGroups.get(featureGroup)) === null || _allFeatureGroups$get === void 0 ? void 0 : _allFeatureGroups$get.displayName, index !== featureGroups.length - 1 && ' | ']
      }, `feature-group-${featureGroup}`);
    })
  });
}